<template>
  <CommonAnalyticsTable
    :stats="stats"
    :total="total"
    :currentMonth="currentMonth"
    :statsClickable="true"
    :showGrossSalesCount="showGrossSalesCount"
    :showActiveStoresRate="showActiveStoresRate"
    :order="order"
    @row-clicked="handleRegionClick"
    @sort="handleSort"
  />
</template>

<script>
import CommonAnalyticsTable from "@/components/analytics/retail/utils/CommonAnalyticsTable.vue";

export default {
  components: {
    CommonAnalyticsTable,
  },

  emits: ["sort", "region-selected"],

  props: {
    stats: { type: Array, required: true },
    total: { type: Object, required: true },
    currentMonth: { type: String, required: true },
    showGrossSalesCount: { type: Boolean, default: false },
    showActiveStoresRate: { type: Boolean, default: false },
    order: { type: String, default: null },
  },

  methods: {
    handleRegionClick(row) {
      this.$emit("region-selected", row.name);
    },

    handleSort(column) {
      this.$emit("sort", column);
    },
  },
};
</script>
